import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import SEO from '../../components/SEO';
import { useAuth } from '../../context/AuthContext';
import './AuthPage.css';

function SignUpPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') || '/account';

  const [form, setForm] = useState({ full_name: '', email: '', phone: '', password: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    setSubmitting(true);
    try {
      await register({
        full_name: form.full_name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        password: form.password,
      });
      navigate(next, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <SEO title="Create account" description="Create an ASG Shading account to keep your delivery details on file and track orders for your retractable awning or pergola system." canonical="/sign-up" noindex />
      <div className="auth-card">
        <p className="auth-eyebrow">ASG Shading</p>
        <h1 className="auth-title">Create your account</h1>
        <p className="auth-subtitle">Save your details for faster checkout and track every order from one dashboard.</p>
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="auth-field">
            <label htmlFor="full_name">Full name</label>
            <input id="full_name" type="text" autoComplete="name" required value={form.full_name} onChange={update('full_name')} />
          </div>
          <div className="auth-field">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" autoComplete="email" required value={form.email} onChange={update('email')} />
          </div>
          <div className="auth-field">
            <label htmlFor="phone">Phone (optional)</label>
            <input id="phone" type="tel" autoComplete="tel" value={form.phone} onChange={update('phone')} />
          </div>
          <div className="auth-field">
            <label htmlFor="password">Password</label>
            {/* UX-16: minLength removed so the styled JS error below
                is the single source of truth. The browser's native
                minLength tooltip was firing before the JS check and
                showed unstyled, untranslated copy. */}
            <input id="password" type="password" autoComplete="new-password" required value={form.password} onChange={update('password')} />
          </div>
          {error && <p className="auth-error" role="alert">{error}</p>}
          <button type="submit" className="auth-btn" disabled={submitting}>
            {submitting ? 'Creating account…' : 'Create account'}
          </button>
          <p className="auth-meta-center">
            Already have an account? <Link to={`/sign-in${next !== '/account' ? `?next=${encodeURIComponent(next)}` : ''}`}>Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default SignUpPage;
